<!--
 * @Date: 2022-10-24 16:01:06
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 15:16:21
 * @FilePath: /nicee-web-tw/src/upgrade-page/views/line-recharge/tappay-page.vue
 * @Description: tappay支付
-->
<template>
  <div class="new-line-recharge-tappay" v-show="show">
    <form class="paypal-form-box" ref="form">
      <div class="form-group card-number-group">
        <label
          for="card-number"
          class="control-label control-label-card-number"
        >
          <span>{{$t('components_recharge_tappay_page_404')}}</span>
          <div>
            <img class="card-logo" src="./images/visa.png" alt="" />
            <img class="card-logo" src="./images/mastercard.png" alt="" />
            <img class="card-logo" src="./images/Discover.png" alt="" />
            <img class="card-logo" src="./images/Amex.png" alt="" />
          </div>
        </label>
        <div class="card-number-box">
          <!-- <img class="card-logo" src="./images/card.png" alt="" /> -->
          <div class="form-control card-number"></div>
        </div>
      </div>
      <div class="time-code-group">
        <div class="form-group expiration-date-group">
          <label for="expiration-date" class="control-label">{{$t('components_recharge_tappay_page_405')}}</label>
          <div
            class="form-control expiration-date"
            id="tappay-expiration-date"
          ></div>
        </div>
        <div class="form-group ccv-group">
          <label for="ccv" class="control-label">{{$t('components_recharge_tappay_page_406')}}</label>
          <div class="form-control ccv" id="form-control-ccv"></div>
        </div>
      </div>
      <div class="remember-box">
        <span class="checkbox-box" @click.stop="toggleSelect">
          <el-checkbox
            ref="checkbox"
            v-model="submitObj.remember"
            shape="square"
          ></el-checkbox>
        </span>
        <span class="message">{{$t('components_recharge_tappay_page_407')}}</span>
      </div>
      <button class="c-button" ref="submitButton" type="submit"></button>
    </form>
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  name: 'TappayPage',
  props: {
    rechargeUuid: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      handler: function(nVal) {
        if (nVal) {
          this.showPage();
        } else {
          this.closePage();
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      show: false, //是否顯示彈窗
      isInit: false, // 是否已經初始化sdk
      cardList: [], //银行卡列表
      loading: false,
      submitObj: {
        remember: true, // 是否記住卡片信息
        prime: '', //支付的prime
        cardId: null //银行卡id
      }
    };
  },
  computed: {
    customClass() {
      return window.innerWidth >= 600 ? 'tappay pc' : 'tappay';
    }
  },
  mounted() {},
  created() {
    if (!window.TPDirect) {
      require('@/sdk/tappay-v5.13.js');
    }
  },
  methods: {
    // 初始化tappay
    init() {
      console.log('init');
      if (!this.isInit) {
        this.$nextTick(() => {
          this.$refs.form.addEventListener('submit', event => {
            event.preventDefault();
            // Get prime
            TPDirect.card.getPrime(result => {
              console.log('result', result);
              if (result.status !== 0) {
                this.$message.error(i18n.t('upgrade_page_views_line_recharge_tappay_page_2055'));
                return;
              }
              this.submitObj.prime = result.card.prime;
              this.submitObj.cardId = null;
              this.submit();
            });
          });
          TPDirect.setupSDK(
            126179,
            'app_rk7WiBr8Llr4pe5Ewpt1Y2WGxGh3fqQc8JnR20TgHdajAqUOrztVvHuRLguk',
            process.env.VUE_APP_ENV === 'production' ? 'production' : 'sandbox'
          );
          TPDirect.card.setup({
            fields: {
              number: {
                element: '.form-control.card-number',
                placeholder: '**** **** **** ****'
              },
              expirationDate: {
                element: document.getElementById('tappay-expiration-date'),
                placeholder: 'MM / YY'
              },
              ccv: {
                element: document.getElementById('form-control-ccv'),
                placeholder: i18n.t('components_recharge_tappay_page_408')
              }
            },
            styles: {
              input: {
                color: 'gray',
                'font-size': '24px'
              },
              // 'input.card-number': {
              //   'font-size': '20px'
              // },
              'input.ccv': {
                // 'font-size': '16px'
              },
              ':focus': {
                color: 'black'
              },
              '.valid': {
                color: 'green'
              },
              '.invalid': {
                color: 'red'
              },
              '@media screen and (max-width: 400px)': {
                input: {
                  color: 'orange'
                }
              }
            },
            // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
            isMaskCreditCardNumber: true,
            maskCreditCardNumberRange: {
              beginIndex: 6,
              endIndex: 11
            }
          });
          // listen for TapPay Field
          TPDirect.card.onUpdate(update => {
            if (update.canGetPrime) {
              // this.$refs.submitButton.removeAttribute('disabled');
            } else {
              // this.$refs.submitButton.setAttribute('disabled', true);
            }

            // number 欄位是錯誤的
            if (update.status.number === 2) {
              this.setNumberFormGroupToError('card-number-group');
            } else if (update.status.number === 0) {
              this.setNumberFormGroupToSuccess('card-number-group');
            } else {
              this.setNumberFormGroupToNormal('card-number-group');
            }

            if (update.status.expiry === 2) {
              this.setNumberFormGroupToError('expiration-date-group');
            } else if (update.status.expiry === 0) {
              this.setNumberFormGroupToSuccess('expiration-date-group');
            } else {
              this.setNumberFormGroupToNormal('expiration-date-group');
            }

            if (update.status.ccv === 2) {
              this.setNumberFormGroupToError('ccv-group');
            } else if (update.status.ccv === 0) {
              this.setNumberFormGroupToSuccess('ccv-group');
            } else {
              this.setNumberFormGroupToNormal('ccv-group');
            }
          });
          this.isInit = true;
        });
      }
    },
    setNumberFormGroupToError(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-error');
      classList.remove('has-success');
    },
    setNumberFormGroupToSuccess(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.add('has-success');
      classList.remove('has-error');
    },
    setNumberFormGroupToNormal(selector) {
      const classList = document.getElementsByClassName(selector)[0].classList;
      classList.remove('has-success');
      classList.remove('has-error');
    },
    // 打開彈窗
    async showPage() {
      this.show = true;
      this.loading = true;
      this.submitObj = {
        remember: true,
        prime: '',
        cardId: null
      };
      this.init();
      this.loading = false;
    },
    // 關閉彈窗
    closePage() {
      this.show = false;
    },
    // 提交
    submit() {
      this.$emit('submit', this.submitObj);
    },
    handleSubmit() {
      this.$refs.submitButton.click();
    },
    toggleSelect() {
      this.submitObj.remember = !this.submitObj.remember;
    }
  }
};
</script>
<style lang="scss">
.new-line-recharge-tappay {
  background: rgba(232, 234, 238, 0.8);
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 1.5rem 1.667rem 0.5rem;
  margin-bottom: 0.8rem;
  .control-label {
    color: #222c43;
    font-size: 1.167rem;
    margin-bottom: 0.667rem;
    display: inline-block;
  }
  .form-group {
    margin-bottom: 3.083rem;
  }
  .form-control {
    height: 3.667rem;
  }
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }
  .card-number-group {
    .control-label-card-number {
      display: flex;
      align-items: center;
      justify-content: space-between;
      // .card-logo {
      //   margin-left: 0.167rem;
      // }
    }
    .card-number-box {
      display: flex;
      align-items: center;
      border-radius: 0.167rem;
      border: 1px solid rgba(60, 60, 67, 0.2);
      background: rgba(255, 255, 255, 1);
      padding-left: 1rem;
    }
    .card-logo {
      width: 1.917rem;
    }
  }
  .time-code-group {
    display: flex;
    .form-control {
      border-radius: 0.167rem;
      border: 1px solid rgba(60, 60, 67, 0.2);
      background: rgba(255, 255, 255, 1);
      padding-left: 1rem;
    }
    .expiration-date-group {
      margin-right: 0.291rem;
    }
    .ccv-group {
      margin-left: 0.291rem;
    }
  }
  .remember-box {
    display: flex;
    align-items: center;
    .checkbox-box {
      display: inline-block;
      padding: 0.5rem;
    }
    .message {
      display: inline-block;
      // margin-left: 0.5rem;
      color: #636d86;
      font-size: 1rem;
    }
  }
  .c-button {
    width: 0;
    height: 0;
    // overflow: hidden;
  }
}
</style>
<style lang="scss">
.new-line-recharge-tappay {
  .remember-box {
    .el-checkbox__input {
      .el-checkbox__inner {
        font-size: 1.2rem;
        width: 1.4rem;
        height: 1.4rem;
        &::after {
          height: 0.8rem;
          left: 0.5rem;
        }
      }
      &.is-checked {
        // background-color: rgb(99, 109, 134);
        .el-checkbox__inner {
          background-color: rgb(99, 109, 134);
          border-color: rgb(99, 109, 134);
          &:hover {
            border-color: rgb(99, 109, 134);
          }
        }
      }
      .el-checkbox__inner {
        &:hover {
          border-color: rgb(99, 109, 134);
        }
      }
    }
  }
}
</style>
